// removed by extract-text-webpack-plugin
module.exports = {"zIndex":"tarifas__zIndex___VG4ld","text_xs":"tarifas__text_xs___2aCRc","bgGray":"tarifas__bgGray___4CFiv"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/nominas/nominaIG/tarifa/tarifas.css
// module id = 951
// module chunks = 0